import {Injectable} from '@angular/core';
import {BaseObservableService} from './base-obeservable-service';
import {DonationProgram} from '../_models/donation-program';

@Injectable({
    providedIn: 'root'
})
export class DonationProgramService extends BaseObservableService<DonationProgram> {
    destination = 'donation-programs';

    getPayouts(id: number | string) {
        return this.http.get(`${this.baseUrl()}/${id}/donation-program-payouts`);
    }

    getSummary(id: number) {
        return this.http.get(`${this.baseUrl()}/${id}/summary`);
    }
}
